import { useState } from 'react';

import Button from '../../../components/ui/Button';

const CommentTemplateCard = ({ template, onEdit, onDelete, onUse }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getCategoryColor = (category) => {
    const colors = {
      'Engagement': 'bg-accent/10 text-accent',
      'Question': 'bg-primary/10 text-primary',
      'Compliment': 'bg-success/10 text-success',
      'Value Add': 'bg-warning/10 text-warning',
      'Networking': 'bg-secondary/10 text-secondary'
    };
    return colors?.[category] || 'bg-muted text-muted-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-card transition-all duration-150">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-semibold text-foreground mb-1">{template?.name}</h3>
          <div className="flex items-center gap-2 flex-wrap">
            <span className={`px-2 py-1 rounded text-xs font-medium ${getCategoryColor(template?.category)}`}>
              {template?.category}
            </span>
            <span className="text-xs text-muted-foreground">{template?.usageCount} uses</span>
            <span className="text-xs text-muted-foreground">•</span>
            <span className="text-xs text-muted-foreground">{template?.successRate}% success</span>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="icon"
            iconName="Edit"
            onClick={() => onEdit(template)}
          />
          <Button
            variant="ghost"
            size="icon"
            iconName="Trash2"
            onClick={() => onDelete(template)}
          />
        </div>
      </div>
      <div className="bg-muted rounded-lg p-3 mb-3">
        <p className="text-sm text-foreground whitespace-pre-wrap">
          {isExpanded ? template?.content : `${template?.content?.substring(0, 120)}${template?.content?.length > 120 ? '...' : ''}`}
        </p>
      </div>
      {template?.variations && template?.variations?.length > 0 && (
        <div className="mb-3">
          <p className="text-xs text-muted-foreground mb-2">{template?.variations?.length} variations available</p>
          <div className="flex flex-wrap gap-2">
            {template?.variations?.slice(0, 3)?.map((variation, index) => (
              <span key={index} className="px-2 py-1 bg-background border border-border rounded text-xs text-foreground">
                Variation {index + 1}
              </span>
            ))}
            {template?.variations?.length > 3 && (
              <span className="px-2 py-1 bg-background border border-border rounded text-xs text-muted-foreground">
                +{template?.variations?.length - 3} more
              </span>
            )}
          </div>
        </div>
      )}
      {template?.personalizationTokens && template?.personalizationTokens?.length > 0 && (
        <div className="mb-3">
          <p className="text-xs text-muted-foreground mb-2">Personalization tokens:</p>
          <div className="flex flex-wrap gap-2">
            {template?.personalizationTokens?.map((token, index) => (
              <span key={index} className="px-2 py-1 bg-primary/10 text-primary rounded text-xs font-mono">
                {token}
              </span>
            ))}
          </div>
        </div>
      )}
      <div className="flex items-center justify-between gap-2">
        <Button
          variant="ghost"
          size="sm"
          iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? 'Show Less' : 'Show More'}
        </Button>
        <Button
          variant="default"
          size="sm"
          iconName="Send"
          iconPosition="left"
          onClick={() => onUse(template)}
        >
          Use Template
        </Button>
      </div>
    </div>
  );
};

export default CommentTemplateCard;